import { CommonModule } from '@angular/common';
import { AfterViewInit, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { NumberRange } from "../../../generated/generated-types";
import { NumberGeneratorService } from '../../services/number-range.service';

@Component({
  selector: 'app-number-generator-input',
  templateUrl: './number-generator-input.component.html',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    TranslatePipe,
    FormlyModule,
    TooltipModule,
    ReactiveFormsModule,
  ]
})
export class NumberGeneratorInputComponent extends FieldType implements AfterViewInit {

  /**
   *
   */
  constructor(
    private numberGeneratorService: NumberGeneratorService
  ) {
    super();


  }

  ngAfterViewInit() {
    this.formControl?.valueChanges.subscribe(x => {
      if (!x && !this.formControl.enabled) { //when reset
        this.formControl.enable();
      }
    });
  }

  async generateClick() {
    let newNumberFunc: () => Promise<NumberRange>;
    let entity = this.props.attributes["entity"] as string;
    let variant = this.props.attributes["variant"] as string;
    let identifier = this.props.attributes["identifier"] as string;

    if (entity)
      newNumberFunc = () => this.numberGeneratorService.generateNewNumber(entity, variant);
    else if (identifier)
      newNumberFunc = () => this.numberGeneratorService.generateNewNumberByIdentifier(identifier);
    else
      throw new Error("Entity (or Identifier *deprecated*) of Number Generator Input missing");

    this.formControl.disable();

    let newNumber = await newNumberFunc();

    if (newNumber) {
      this.field.formControl.setValue(newNumber.combinedKey);
      this.formControl.disable();
    }
    else
      this.formControl.enable();
  }
}
